import { useEffect, useState } from 'react';

export const useHistoryState = <T>(
  key: string,
  defaultValue: T,
): [T, (value: T) => void] => {
  const [value, setValue] = useState<T>(
    (history.state?.[key] as T) ?? defaultValue,
  );

  useEffect(() => {
    history.replaceState({ ...history.state, [key]: value }, '');
  }, [key, value]);

  return [value, setValue];
};
